// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import Ui__DropdownController from "./ui/dropdown_controller";
application.register("ui--dropdown", Ui__DropdownController);

import Ui__UploadPreviewController from "./ui/upload_preview_controller";
application.register("ui--upload-preview", Ui__UploadPreviewController);

import Ui__CollapsibleCardController from "./ui/collapsible_card_controller";
application.register("ui--collapsible-card", Ui__CollapsibleCardController);

import Ui__FancySelectController from "./ui/fancy_select_controller";
application.register("ui--fancy-select", Ui__FancySelectController);

import Ui__ModalController from "./ui/modal_controller";
application.register("ui--modal", Ui__ModalController);

import Ui__SelectAndFocusInputController from "./ui/select_and_focus_input_controller";
application.register(
  "ui--select-and-focus-input",
  Ui__SelectAndFocusInputController
);

// Form specific controllers
import Documents__FormController from "./documents/form_controller";
application.register("documents--form", Documents__FormController);

import CompanyDetails__FormController from "./company-details/form_controller";
application.register("company-details--form", CompanyDetails__FormController);

import BankAccounts__FormController from "./bank-accounts/form_controller";
application.register("bank-accounts--form", BankAccounts__FormController);

import Shared__MainNavigationController from "./shared/main_navigation_controller";
application.register(
  "shared--main-navigation",
  Shared__MainNavigationController
);
